import { useContext } from "react";

import AuthContext, { AuthContextInterface } from "../contexts/auth/context";

const useAuth = (): AuthContextInterface => useContext(AuthContext);

export default useAuth;
